import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { TableBaseStyle } from './PLMSettingStyle';
import { PLM_CSV_SET } from './PLMSetting';
import Button from '@material-ui/core/Button';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import UneditableSwitchStringInput from '../../../atoms/Input/UneditableSwitchStringInput';

type PLMSettingGridRowProps = {
  plmSetting: PLM_CSV_SET;
  rowIndexNo: number;
  onClickDeleteButton: (indexNo: number) => void;
  onChangeData: (targetRow: PLM_CSV_SET) => void;
};

const PLMSettingGridRow: React.FC<PLMSettingGridRowProps> = (props) => {
  const tableStyle = TableBaseStyle();
  const [plmSetting, setPLMSetting] = useState<PLM_CSV_SET>(props.plmSetting); //データ初期値
  const [isEdit, setIsEdit] = useState<boolean>(false); //変更フラグ データを編集したらtrue
  const { t, i18n } = useTranslation();

  /**
   * データ変更通知
   */
  useEffect(() => {
    //データ初期値にセットされている内容を再描画時に変えたい場合、useEffectが必要
    //console.debug(['PLMSettingGridRow - useEffect props.plmSetting', props.plmSetting]);
    setPLMSetting({ ...props.plmSetting });
    setIsEdit(false);
  }, [props.plmSetting]);

  /**
   * 値を変更した内容を管理
   * @param key
   * @returns
   */
  const onChangeCell = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    console.debug(['onChangeCell - key isEdit', key, isEdit]);
    setIsEdit(true);
    setPLMSetting({ ...plmSetting, [key]: event.target.value });
  };

  /**
   * IP設定データ変更通知
   * @param editRow
   * @param event
   */
  const onChangeIPonBlurCell = (editRow: PLM_CSV_SET) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const ip = event.target.value;
    // ipアドレスチェック
    if (ip.match(/^\d{1,3}(\.\d{1,3}){3}$/)) {
      //カリー化された関数
      onChangeData(editRow, isEdit)(event);
    } else {
      //フォーマとチェックがNGの場合元に戻す
      setPLMSetting({ ...editRow, PLM_IPADR: props.plmSetting.PLM_IPADR });

      //親データにも通知
      editRow.PLM_IPADR = props.plmSetting.PLM_IPADR;
      onChangeData(editRow, isEdit)(event);
    }
    //console.debug(['onChangePassWordCell - pass isEdit', userID, isEdit]);
  };

  /**
   * 時間設定データ変更通知
   * @param editRow
   * @param event
   */
  const onChangeHHMMonBlurCell = (editRow: PLM_CSV_SET) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const ip = event.target.value;
    // ipアドレスチェック
    if (ip.match(/^([01][0-9]|2[0-3]):[0-5][0-9]$/)) {
      //カリー化された関数
      onChangeData(editRow, isEdit)(event);
    } else {
      //フォーマとチェックがNGの場合元に戻す
      setPLMSetting({ ...editRow, PLM_HHMM: props.plmSetting.PLM_HHMM });

      //親データにも通知
      editRow.PLM_HHMM = props.plmSetting.PLM_HHMM;
      onChangeData(editRow, isEdit)(event);
    }
    //console.debug(['onChangePassWordCell - pass isEdit', userID, isEdit]);
  };

  /**
   *データ変更通知
   * @param editRow
   * @param event
   */

  /**
   * 要求設定データ変更通知
   * @param editRow
   * @param event
   */
  const onClickPLM_REQ_FLGButton = (editRow: PLM_CSV_SET) => (event: React.ChangeEvent<HTMLInputElement>) => {
    console.debug(['onClickPLM_STATButton- editRow,baseData', editRow, props.plmSetting]);
    if (plmSetting.PLM_REQ_FLG === null) {
      plmSetting.PLM_REQ_FLG = 1;
    } else if (plmSetting.PLM_REQ_FLG === 0) {
      plmSetting.PLM_REQ_FLG = 1;
    } else {
      plmSetting.PLM_REQ_FLG = 0;
    }

    //これだとisEditがtureになるのが間に合わない為
    //onChangeData(plmSetting, true)(event)　true直接呼ぶ
    setIsEdit(true);

    setPLMSetting({ ...plmSetting });
    onChangeData(plmSetting, true)(event);
  };

  /**
   * 上位にデータ変更通知
   * @param editRow　編集対象データ
   * @param isEdit 編集フラグ
   * @returns
   */
  const onChangeData = (editRow: PLM_CSV_SET, editFlg: boolean) => (event: React.ChangeEvent<HTMLInputElement>) => {
    if (editFlg) {
      //console.debug(['onChangeData - editRow,baseData', editRow, props.plmSetting]);
      console.debug(['onChangeData - editRow,baseData', editRow, props.plmSetting, editRow.isEditPlmState]);
      props.onChangeData(editRow);
    }
  };

  /**
   * ステータス表示文字を返す
   */
  const getStatusString = (editRow: PLM_CSV_SET): string => {
    switch (editRow.PLM_STAT) {
      case 0:
        return t('PLMSettingGridRow.正常', '正常');
      case 1:
        return t('PLMSettingGridRow.異常', '異常');
      default:
        return t('PLMSettingGridRow.不明', '不明');
    }
  };

  return (
    <TableRow key={props.rowIndexNo}>
      {/* No */}
      <TableCell className={tableStyle.bodyCell} width={50}>
        <div>{props.rowIndexNo}</div>
      </TableCell>
      {/* 名称 */}
      <TableCell className={tableStyle.bodyCell} width={200}>
        <input
          className={tableStyle.textField}
          type="text"
          maxLength={255}
          defaultValue={plmSetting.PLM_NAME}
          value={plmSetting.PLM_NAME}
          onChange={onChangeCell('PLM_NAME')}
          onBlur={onChangeData(plmSetting, isEdit)}
          disabled={!plmSetting.isEditPlmState}
        />
      </TableCell>
      {/* CSV保存パス */}
      <TableCell className={tableStyle.bodyCell}>
        <input
          className={tableStyle.textField}
          type="text"
          maxLength={128}
          defaultValue={plmSetting.PLM_CSV_PATH}
          value={plmSetting.PLM_CSV_PATH}
          onChange={onChangeCell('PLM_CSV_PATH')}
          onBlur={onChangeData(plmSetting, isEdit)}
          disabled={!plmSetting.isEditPlmState}
        />
      </TableCell>
      {/* ユーザーID */}
      <TableCell className={tableStyle.bodyCell} width={100}>
        <input
          className={tableStyle.textField}
          type="text"
          maxLength={12}
          defaultValue={plmSetting.PLM_USERID}
          value={plmSetting.PLM_USERID}
          onChange={onChangeCell('PLM_USERID')}
          onBlur={onChangeData(plmSetting, isEdit)}
          disabled={!plmSetting.isEditPlmState}
        />
      </TableCell>
      {/* パスワード */}
      <TableCell className={tableStyle.bodyCell} width={100}>
        <input
          className={tableStyle.textField}
          type="password"
          maxLength={12}
          defaultValue={plmSetting.PLM_PASSWD}
          value={plmSetting.PLM_PASSWD}
          onChange={onChangeCell('PLM_PASSWD')}
          onBlur={onChangeData(plmSetting, isEdit)}
          disabled={!plmSetting.isEditPlmState}
        />
      </TableCell>
      {/* IPアドレス */}
      <TableCell className={tableStyle.bodyCell} width={100}>
        <input
          className={tableStyle.textField}
          type="text"
          maxLength={15}
          defaultValue={plmSetting.PLM_IPADR}
          value={plmSetting.PLM_IPADR}
          onChange={onChangeCell('PLM_IPADR')}
          onBlur={onChangeIPonBlurCell(plmSetting)}
          disabled={!plmSetting.isEditPlmState}
        />
      </TableCell>
      {/* 送信時間 */}
      <TableCell className={tableStyle.bodyCellCenter} width={100}>
        {plmSetting.isEditPlmState === true ? (
          <input
            className={tableStyle.textField}
            type="text"
            maxLength={5}
            defaultValue={plmSetting.PLM_HHMM}
            value={plmSetting.PLM_HHMM}
            onChange={onChangeCell('PLM_HHMM')}
            onBlur={onChangeHHMMonBlurCell(plmSetting)}
            disabled={!plmSetting.isEditPlmState}
          />
        ) : (
          <div>{plmSetting.PLM_HHMM}</div>
        )}
      </TableCell>
      <TableCell className={tableStyle.bodyCellCenter} width={100}>
        {plmSetting.isEditPlmState === true ? (
          <Switch
            checked={plmSetting.PLM_REQ_FLG === 1 ? true : false}
            inputProps={{ 'aria-label': 'controlled' }}
            onChange={onClickPLM_REQ_FLGButton(plmSetting)}
          ></Switch>
        ) : (
          <div>{t('PLMSettingGridRow.要求中', '要求中')}</div>
        )}
      </TableCell>
      {/* ステータス */}
      <TableCell className={tableStyle.bodyCell} width={100}>
        <div>{getStatusString(plmSetting)}</div>
      </TableCell>

      <TableCell className={tableStyle.bodyCellCenter} width={100}>
        {plmSetting.isEditPlmState === true ? (
          <Button variant="contained" color="primary" onClick={(e) => props.onClickDeleteButton(plmSetting.indexNo)}>
            {t('PLMSettingGridRow.削除', '削除')}
          </Button>
        ) : (
          <div>{t('PLMSettingGridRow.削除不可', '削除不可')}</div>
        )}
      </TableCell>
    </TableRow>
  );
};

export default PLMSettingGridRow;
